<template>
  <v-app dark>
    <main>
      <v-container fluid fill-height>
        <v-layout>
          <v-flex sm6 offset-sm3>
            <v-card>
              <v-container :class="{ 'error' : hasErrors }">
                <v-card class="elevation-0">
                    <v-card-text>
                      <v-container fluid>
                        <v-layout row>
                          <v-flex xs12>
                            <v-text-field
                              type="email"
                              name="email"
                              label="Email"
                              v-model.trim="email"
                              required
                              dark
                            ></v-text-field>
                          </v-flex>
                        </v-layout>
                        <v-layout row>
                          <v-flex xs12>
                            <v-text-field
                              type="password"
                              name="password"
                              label="Password"
                              v-model.trim="password"
                              required
                              dark
                            ></v-text-field>
                          </v-flex>
                        </v-layout>
                          <v-btn
                            success
                            @click.prevent="login"
                            :class="{ 'loading': isLoading }"
                            >
                            Login
                          </v-btn>
                          <div>
                             <p class="text-xs-right">Need an account? <router-link class="success--text" to="/register">Register</router-link></p>
                          </div>
                      </v-container>
                    </v-card-text>
                </v-card>
              </v-container>
            </v-card>
            <div class="error" v-if="hasErrors">
                <p v-for="error in errors">{{ error }}</p>
            </div>
          </v-flex>
        </v-layout>
        <!--v-router-->
      </v-container>
    </main>
  </v-app>

</template>

<script>
import firebase from 'firebase'
export default {
  name: 'login',
  data () {
    return {
      email: '',
      password: '',
      errors: [],
      isLoading: false
    }
  },
  computed: {
    hasErrors () {
      return this.errors.length > 0
    }
  },
  methods: {
    isEmpty () {
      if (
        this.email.length === 0 ||
        this.password.length === 0
      ) {
        return true
      }
      return false
    },
    login () {
      this.errors = []

      if (this.isFormValid()) {
        this.isLoading = true

        firebase
          .auth()
          .signInWithEmailAndPassword(this.email, this.password)
          .then(user => {
            this.$store.dispatch('setUser', user)
            this.$router.push('/')
          })
          .catch(error => {
            this.errors.push(error.message)
            this.isLoading = false
          })
      }
    },
    isFormValid () {
      if (this.email.length > 0 && this.password.length > 0) {
        return true
      } else if (this.isEmpty()) {
        this.errors.push('Please complete all fields')
        return false
      }
      return false
    }
  }
}
</script>

<style lang="stylus">
  @import '../stylus/main'
  .error
    padding: 5px 5px 0
    background-color: #444 !important
    border:1px solid #ff5252 !important
</style>



// WEBPACK FOOTER //
// Login.vue?1a870158